export const SIMILAR_SOUNDS = 'SIMILAR_SOUNDS';
